module.exports = __webpack_public_path__ + "img/Product05.b165ffc9.png";